import { KeyboardEvent } from 'react';

/**
 * Keydown handler factory for clickable icons / SVGs treated as buttons.
 * Invokes `action` only on Enter or Space (with preventDefault for Space).
 */
const handleIconKeyDown = (action: (e: KeyboardEvent) => void) => (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        action(e);
    }
};

export default handleIconKeyDown;
